import React, { useState, useEffect } from 'react';

const HERO_IMAGES = [
  '/hero/Copilot_20260728_154553.webp',
  '/hero/Copilot_20260728_154735.webp',
//   '/hero/Copilot_20260728_154926.png',
  '/hero/ChatGPT Image Jul 28, 2026, 04_23_28 PM.webp',
];

export function Hero() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % HERO_IMAGES.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section id="hero" className="hero-section">
      {HERO_IMAGES.map((src, i) => (
        <img
          key={src}
          src={src}
          alt=""
          className={`hero-carousel-img${i === active ? ' active' : ''}`}
          loading={i === 0 ? 'eager' : 'lazy'}
          fetchpriority={i === 0 ? 'high' : 'auto'}
        />
      ))}
      <div className="hero-dots">
        {HERO_IMAGES.map((src, i) => (
          <button
            key={src}
            className={`hero-dot${i === active ? ' active' : ''}`}
            onClick={() => setActive(i)}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
